import { useCallback } from 'react';
import { useVideoPlayerStore } from '@embed/components/VideoPlayer/store';
import { videoPlayerInterruptionEventCallbackSelector } from '@embed/components/VideoPlayer/store/selectors';
/**
 * Provides a callback that can be interrupted by the integration given the event name.
 * @param event The player interrupt event
 * @param onResolve Callback to execute when interrupt is resolved
 * @param onReject Optional callback to execute when interrupt is rejected
 * @returns A callback function that handles the interruption logic
 */
export function useInterruptibleCallback(event, onResolve, onReject) {
    const callback = useVideoPlayerStore(videoPlayerInterruptionEventCallbackSelector(event));
    return useCallback(async (event) => {
        try {
            await callback();
            onResolve(event);
        }
        catch (error) {
            event.stopPropagation();
            event.preventDefault();
            onReject?.(event);
        }
    }, [onResolve, onReject, callback]);
}
